var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvcIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6874",
    "data-name": "Group 6874",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.763,
    height: 33.99,
    viewBox: "0 0 25.763 33.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15183",
    "data-name": "Path 15183",
    d: "M93.93,23.923H92.681v-3.51a9.406,9.406,0,1,0-18.813-.007v3.51H72.627A2.229,2.229,0,0,0,70.4,26.143V42.764a2.229,2.229,0,0,0,2.227,2.227h21.31a2.229,2.229,0,0,0,2.227-2.227V26.143A2.238,2.238,0,0,0,93.93,23.923ZM76.7,20.406a6.576,6.576,0,1,1,13.152,0v3.5H76.7ZM93.319,42.16H73.23V26.753h20.1V42.16Z",
    transform: "translate(-70.4 -11)",
    fill: "#51aabc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15184",
    "data-name": "Path 15184",
    d: "M237.015,342.779a1.412,1.412,0,0,0,1.415-1.415v-3.649a1.415,1.415,0,0,0-2.83,0v3.649A1.417,1.417,0,0,0,237.015,342.779Z",
    transform: "translate(-224.14 -313.735)",
    fill: "#51aabc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvcIcon);
export default __webpack_public_path__ + "static/media/cvc-icon.d3b643bd.svg";
export { ForwardRef as ReactComponent };